export class User {
	public id: string;
	public firstName: string;
	public lastName: string;
	public fullName: string;
	public email: string;
	public logoutUrl: string;

	constructor(id: string, firstName: string, lastName: string, email: string, logoutUrl: string) {
		this.id = id;
		this.firstName = firstName;
		this.lastName = lastName;
		this.fullName = `${firstName} ${lastName}`;
		this.email = email;
		this.logoutUrl = logoutUrl;
	}
}
